module.exports = __webpack_public_path__ + "assets/img/5f47b1888014d24089b4fe95e23fee44.svg";